import { useCallback, useState } from 'react'
import { projectService } from '../services/projectService'
import type { CreateProjectData, Project } from '../types/project'

interface UseProjectsReturn {
  projects: Project[]
  isLoading: boolean
  error: Error | null
  refreshProjects: () => Promise<void>
}

export const useProjects = (): UseProjectsReturn => {
  const [projects, setProjects] = useState<Project[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const refreshProjects = useCallback(async () => {
    setIsLoading(true)
    try {
      const data = await projectService.getProjects()
      setProjects(data.items)
      setError(null)
    } catch (err) {
      console.error('Failed to fetch projects:', err)
      setError(
        err instanceof Error ? err : new Error('Failed to fetch projects'),
      )
    } finally {
      setIsLoading(false)
    }
  }, [])

  return {
    projects,
    isLoading,
    error,
    refreshProjects,
  }
}
